// Helper function to generate image/asset fragments
const createAssetFragment = (fieldName: string) => `
${fieldName} {
  url
  title
  width
  height
}
`

// Asset fragments
export const ASSET = createAssetFragment('asset')

export const ASSET_MOBILE = createAssetFragment('assetMobile')
export const ASSET_DESKTOP = createAssetFragment('assetDesktop')

export const ASSETS_MOBILE = createAssetFragment('assetsMobile')
export const ASSETS_DESKTOP = createAssetFragment('assetsDesktop')

export const IMAGE = createAssetFragment('image')

export const IMAGE_MOBILE = createAssetFragment('imageMobile')
export const IMAGE_DESKTOP = createAssetFragment('imageDesktop')

export const IMAGES_MOBILE = createAssetFragment('imagesMobile')
export const IMAGES_DESKTOP = createAssetFragment('imagesDesktop')

export const BACKGROUND_IMAGE = createAssetFragment('backgroundImage')

export const BACKGROUND_IMAGE_MOBILE = createAssetFragment('backgroundImageMobile')
export const BACKGROUND_IMAGE_DESKTOP = createAssetFragment('backgroundImageDesktop')

export const PREVIEW_IMAGE_MOBILE = createAssetFragment('previewImageMobile')
export const PREVIEW_IMAGE_DESKTOP = createAssetFragment('previewImageDesktop')

export const BACKGROUND_ASSET_MOBILE = createAssetFragment('backgroundAssetMobile')
export const BACKGROUND_ASSET_DESKTOP = createAssetFragment('backgroundAssetDesktop')

export const ICON_FIELD = createAssetFragment('iconField')

export const ICON_FIELD2 = createAssetFragment('iconField2')

export const POSTER = createAssetFragment('poster')

export const HOVER_IMAGE = createAssetFragment('hoverImage')